import { chargingSessionReducer } from './charging'
import { locationDetailReducer, locationsListReducer } from './locations'
import { combineReducers } from 'redux'
import {
    errorReducer,
    valueHolderReducer,
    asyncPagedActionReducer,
    asyncActionReducer,
} from './../../shared/redux/reducers/common'
import { LOGIN, SET_PAYMENT_SETTINGS } from '../../shared/redux/const'
import {
    CHANGE_SEARCH_FILTER,
    CHANGE_AVAILABILITY_FILTER,
    CHANGE_DISTANCE_FILTER,
    CHANGE_CONNECTOR_FILTER,
    FETCH_LOCATIONS,
    FETCH_LOCATION_DETAIL,
    MAP_TOKEN,
    CHARGING_SESSION,
    START_CHARGING,
    SET_CAR,
    STOP_CHARGING,
    FETCH_CHARGING_HISTORY,
    CHARGING_HISTORY_FILTER,
    EDIT_USER,
    FETCH_PAYMENT_DETAILS,
    SET_PAYMENT_STATE,
    CHANGE_SORT_FILTER,
    TENANT,
    FETCH_CONNECTOR_PRICING_CONDITIONS,
} from '../const'
import { userLoginReducer } from './user'

export default combineReducers({
    user: combineReducers({
        login: valueHolderReducer(LOGIN, { isLoggedIn: false, isAnonymous: false, user: null }, userLoginReducer),
        edit: asyncActionReducer(EDIT_USER, null),
    }),
    tenant: valueHolderReducer(TENANT),
    filter: combineReducers({
        search: valueHolderReducer(CHANGE_SEARCH_FILTER),
        availability: valueHolderReducer(CHANGE_AVAILABILITY_FILTER, false),
        distance: valueHolderReducer(CHANGE_DISTANCE_FILTER, {
            km: undefined,
            location: undefined,
        }),
        connector: valueHolderReducer(CHANGE_CONNECTOR_FILTER, undefined),
        sortByDistance: valueHolderReducer(CHANGE_SORT_FILTER, true),
    }),
    locations: asyncActionReducer(FETCH_LOCATIONS, [], locationsListReducer),
    locationDetail: asyncActionReducer(FETCH_LOCATION_DETAIL, undefined, locationDetailReducer),
    mapToken: valueHolderReducer(MAP_TOKEN),
    error: errorReducer(),
    chargingSession: valueHolderReducer(CHARGING_SESSION, undefined, chargingSessionReducer),
    connectorPricingConditions: asyncActionReducer(FETCH_CONNECTOR_PRICING_CONDITIONS),
    startCharging: asyncActionReducer(START_CHARGING),
    stopCharging: asyncActionReducer(STOP_CHARGING),
    car: valueHolderReducer(SET_CAR),
    chargingHistory: asyncPagedActionReducer(FETCH_CHARGING_HISTORY),
    chargingHistoryFilter: valueHolderReducer(CHARGING_HISTORY_FILTER, 0),
    payment: combineReducers({
        paymentDetails: asyncActionReducer(FETCH_PAYMENT_DETAILS),
        paymentState: valueHolderReducer(SET_PAYMENT_STATE, null),
    }),
    paymentSettings: valueHolderReducer(SET_PAYMENT_SETTINGS),
})
